import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import useAuthStore from "./useAuthStore";
import Base64e from "../components/encodedecode/encode";

interface PitchesState {
  rows: any[];
  total: number;
  totalPages: number;
  currentPage: number;
  loading: boolean;
  search: string;
  limit: number;
  getPitches: (page: number) => Promise<void>;
  deleteRequest:(requestId: number)=>Promise<void>;
}

export const usePitchesStore = create<PitchesState>((set, get) => ({
  rows: [],
  total: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  search: "",
  limit: 10,  // Default limit can be set as per your requirement

  getPitches: async (page) => {
    set({ loading: true });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) {
        set({ loading: false });
        console.error("User not authenticated.");
        return;
      }

      const requestData = {
        id: Base64e.encode(user.id + ""),
        page: page,  // You may adjust the multiplication logic if necessary
        limit: 10,
        search: "",  // You can pass the search term dynamically
        status: 0,
      };

      const response = await axiosInstance.post("getuserRequests", requestData);

      if (response.status === 200) {
        const updatedRows = response.data.rows.map((v: any) => {
          v.loading = false;
          v.from = parseInt(v.from);
          v.to = parseInt(v.to);
          return v;
        });

        set({
          rows: updatedRows,
          total: response.data.count,
          totalPages: Math.ceil(response.data.count / 10),
          currentPage: page,
          loading: false,
        });

        window.screenTop = 300;  // This might need to be adjusted depending on your requirement
      }
    } catch (error) {
      console.error("Error fetching pitches:", error);
      set({ loading: false });
    }
  },
  deleteRequest: async (requestId) => {
    

    try {
      const data = {
        requestId: requestId,
        
      };

      await axiosInstance.post("deleteRequest", data);

      // Optionally refresh matches after blocking a user
      get().getPitches(0);

      console.log(`Request ${requestId} blocked successfully.`);
    } catch (error) {
      console.error("Error blocking user:", error);
    }
  },
}));
